


<template>
  <div>

        <el-form class="select" style="display: flex; flex-wrap: wrap;">

            <el-form-item label="学生姓名:" label-width="100px" style="width: 30%;" v-if="toAdd != '学科组'">
              <!-- <el-input  placeholder="请输入学生姓名"  v-model="teacherName"  style="width: 100%" clearable v-if="isMub === 3"></el-input> -->
              <el-select  placeholder="请选择"   v-model="teacherName"  style="width: 100%" clearable  filterable  >
                <el-option v-for="item in teacherArr"  :key="item.id"  :value="item.id"  :label="item.realname" >  </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="学科组:" label-width="100px" style="width: 30%;" v-else>
              <el-select  placeholder="请选择学科组"  v-model="SubjectGroup"  style="width: 100%" clearable  filterable  >
                 <el-option v-for="item in SubjectGroupList" :key="item.teacherId" :label="item.teacherName"  :value="item.teacherId"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="学生状态:" label-width="100px" style="width: 30%;" v-if="isMub != 3">
              <el-select v-model="studentStatus"  filterable placeholder="请选择学生状态"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in studentStatusList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="学生类型:" label-width="100px" style="width: 30%;">
              <el-select v-model="newClassType"  filterable placeholder="请选择学生类型"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in newClassTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="所在地域:" label-width="100px" style="width: 30%;">
              <el-select  placeholder="请选择所在地域"  v-model="regionName"  style="width: 100%"   clearable  filterable  >
                <el-option  v-for="item in optionsListt" :key="item.id"  :value="item.dictType"  :label="item.dictValue"  >  </el-option>
              </el-select>
            </el-form-item>

            <el-form-item 
              :label="
                  isMub === 1 ? '首次课日期' : 
                  isMub === 2 ? '新增课日期' :
                  isMub === 3 ? '上课日期' :
                  isMub === 4 ? '上课日期' :
                  isMub === 5 ? '流失日期' : '续报日期'
              " 
              label-width="100px" style="width: 50%;text-align: justify;">
              <el-date-picker v-model="dateTimeList"   type="daterange"  style="width: 100%;"   value-format="yyyy-MM-dd"   range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期">   </el-date-picker>
            </el-form-item>


            <el-form-item label="计算方式:" label-width="100px" style="width: 30%;" v-if="isMub === 3">
              <el-select v-model="courseType"  filterable placeholder="请选择计算方式"  style="width: 100%" clearable >
                <el-option style="margin-left: 10px" v-for="teacher in courseTypeList"  :key="teacher.id"   :label="teacher.name"  :value="teacher.id"  > </el-option>
              </el-select>
            </el-form-item>


        </el-form>


        <div style=" text-align: end; padding: 10px;">
          <el-button @click="handleClear" icon="el-icon-close" size="small" class="btns">清除</el-button>
          <el-button type="primary" @click="handleSearch" size="small" class="btns" icon="el-icon-search">搜索</el-button>
          <el-button type="primary" icon="el-icon-download" size="small" class="btns" @click="handleDownload">导出</el-button>
        </div>




    <div style="margin-top: 15px;" v-if="isMub === 10">

      <div style="display: flex;justify-content: space-between;margin-bottom: 10px;margin-top: 10px;" v-for="(item,index) in dateList" :key="index" class="chart-item">
       
        <el-card style="width: 23%; border-radius: 15px;">
            <div style="text-align: start;">{{ fonttype.name1 }}</div>
            <div style="font-size: 40px;font-weight: 900;text-align: start;">{{ item.endingNumber ? item.endingNumber : 0 }} / 20%</div>
            <div style="display: flex; margin-top: 10px;">
              <div style="color: #989090;font-size: 13px;">{{ calculationType === 1  ?  '差异率' : calculationType === 2  ?  '差值' : '差异率' }}</div>
              <div style="padding-top: 2px;padding-left: 3px;"  :style="{ color:item.endingType === '1' ?  'rgb(45 202 46)' : item.endingType === '2' ? '#ed1313' : ''}">
                <i :class="{ 'el-icon-caret-top': item.endingType === '1',  'el-icon-caret-bottom': item.endingType === '2' , 'el-icon-minus': item.endingType === '3',}"></i>
                <span>{{ calculationType === 1 ? item.endingPercentage : calculationType === 2 ? item.endingDiff : '' }}</span>
              </div>
            </div>
        </el-card>

        <el-card style="width: 23%; border-radius: 15px;">
            <div style="text-align: start;">{{ fonttype.name2 }}</div>
            <div style="font-size: 40px;font-weight: 900;text-align: start;">{{ item.studentNumber ? item.studentNumber : 0 }} / 20%</div>
            <div style="display: flex; margin-top: 10px;">
              <div style="color: #989090;font-size: 13px;">{{ calculationType === 1  ?  '差异率' : calculationType === 2  ?  '差值' : '差异率' }}</div>
              <div style="padding-top: 2px;padding-left: 3px;"  :style="{ color:item.studentType === '1' ?  'rgb(45 202 46)' : item.studentType === '2' ? '#ed1313' : ''}">
                <i :class="{ 'el-icon-caret-top': item.studentType === '1',  'el-icon-caret-bottom': item.studentType === '2', 'el-icon-minus': item.studentType === '3', }"></i>
                <span>{{ calculationType === 1 ? item.studentPercentage : calculationType === 2 ? item.studentDiff : '' }}</span>
              </div>
            </div>
        </el-card>

        <el-card style="width: 23%; border-radius: 15px;">
            <div style="text-align: start;">{{ fonttype.name3 }}</div>
            <div style="font-size: 40px;font-weight: 900;text-align: start;">{{ item.classNumber ? item.classNumber : 0 }} / 20%</div>
            <div style="display: flex; margin-top: 10px;">
              <div style="color: #989090;font-size: 13px;">{{ calculationType === 1  ?  '差异率' : calculationType === 2  ?  '差值' : '差异率' }}</div>
              <div style="padding-top: 2px;padding-left: 3px;"  :style="{ color:item.classType === '1' ?  'rgb(45 202 46)' : item.classType === '2' ? '#ed1313' : ''}">
                <i :class="{ 'el-icon-caret-top': item.classType === '1',  'el-icon-caret-bottom': item.classType === '2', 'el-icon-minus': item.classType === '3', }"></i>
                <span>{{ calculationType === 1 ? item.classPercentage : calculationType === 2 ? item.classDiff : '' }}</span>
              </div>
            </div>
        </el-card>

        <el-card style="width: 23%; border-radius: 15px;">
            <div style="text-align: start;">{{ fonttype.name4 }}</div>
            <div style="font-size: 40px;font-weight: 900;text-align: start;">{{ item.categoryNumber ? item.categoryNumber : 0 }} / 20%</div>
            <div style="display: flex; margin-top: 10px;">
              <div style="color: #989090;font-size: 13px;">{{ calculationType === 1  ?  '差异率' : calculationType === 2  ?  '差值' : '差异率' }}</div>
              <div style="padding-top: 2px;padding-left: 3px;"  :style="{ color:item.categoryType === '1' ?  'rgb(45 202 46)' : item.categoryType === '2' ? '#ed1313' : ''}">
                <i :class="{ 'el-icon-caret-top': item.categoryType === '1',  'el-icon-caret-bottom': item.categoryType === '2', 'el-icon-minus': item.categoryType === '3', }"></i>
                <span>{{ calculationType === 1 ? item.categoryPercentage : calculationType === 2 ? item.categoryDiff : '' }}</span>
              </div>
            </div>
        </el-card>

      </div>

    </div>


    <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}"  :data="dataTableList" border height="700">
        <el-table-column prop="studentName" header-align="center"  label="学生姓名" v-if="toAdd != '学科组'"></el-table-column>
        <el-table-column prop="" header-align="center"  label="学科组" v-else></el-table-column>

        <el-table-column prop="classType" header-align="center"  label="学生类型" >
          <template slot-scope="scope">
            <span v-if="scope.row.classType === 1"> 规划</span>
            <span v-if="scope.row.classType === 2"> 线下</span>
            <span v-if="scope.row.classType === 3"> 纯补课</span>
            <span v-if="scope.row.classType === '规划'"> 规划</span>
            <span v-if="scope.row.classType === '线下'"> 线下</span>
            <span v-if="scope.row.classType === '纯补课'"> 纯补课</span>
          </template>
        </el-table-column>

        <el-table-column v-if="isMub !=3" prop="regionName" header-align="center"  label="所属地域" ></el-table-column>
        <el-table-column v-if="isMub ==3" prop="regionNames" header-align="center"  label="所属地域" ></el-table-column>


        <el-table-column prop="entiretyNum" header-align="center"  label="整体课数量" v-if="isMub ===1"></el-table-column>
        <el-table-column prop="lossProductNum" header-align="center"  label="整体课数量" v-if="isMub === 5"></el-table-column>
        
        <el-table-column prop="newCourseNum" header-align="center"  label="新增课数量" v-if="isMub === 2"></el-table-column>

        <el-table-column prop="entiretyNumber" header-align="center"  label="整体到课率" v-if="isMub === 3"></el-table-column>
        
        <el-table-column prop="" header-align="center"  label="取消课数量/率" v-if="isMub === 4">
          <template slot-scope="scope">
            <div>{{ scope.row.cancelCourseNum }} / {{ scope.row.cancelCourseNumPercentage }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="studentState" header-align="center"  label="学生状态" v-if="isMub === 5"></el-table-column>
        <el-table-column prop="studentStatus" header-align="center"  label="学生状态" v-if="isMub === 6"></el-table-column>
        <el-table-column prop="lessonsNum" header-align="center"  label="已上课节数" v-if="isMub === 6"></el-table-column>

        <el-table-column header-align="center" label="查看详情" width="150px">
          <template slot-scope="scope">
            <el-button type="text" @click="details(scope.row)">详情</el-button>
          </template>
        </el-table-column>

    </el-table>


     <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"  :current-page="pageNum" :page-size="pageSize"  
        layout="prev, pager, next,sizes, jumper" :total="total">
     </el-pagination>


    <el-dialog width="80%" :visible.sync="showPopUpNotification" :before-close="showPopUpNotificationCler" :close-on-click-modal="false" modal-append-to-body :append-to-body="true">
        <component v-if="showPopUpNotification" :is="isComponents" :paramsComponents="params_ZUJIAN" :isMub="isMub" :TabsType="TabsType"></component>
    </el-dialog>

   
  </div>
</template>



<script>

import axios from "axios";
import apiBaseUrl from "../../../config/api";
import { getTeachers_s,  } from "@/api/firstClassApi";
import * as echarts from 'echarts';
import loadingUtils from "../../utils/loading";
import { getStudentsType } from "@/api/fiveClassApi"


import fistClassComponents from '../fistClass.vue';
import feedBackComponents from '../feedBack.vue';
import asYouPleaseComponents from '../asYouPlease.vue';
import TurnoverRateDetails from '../TurnoverRateDetails.vue';
import ContinuationRateEChartDetails from '../ContinuationRateEChartDetails.vue';

export default {
  name: 'FistClassTableStudentStart',
  components: {
    fistClassComponents,
    feedBackComponents,
    asYouPleaseComponents, 
    TurnoverRateDetails,
    ContinuationRateEChartDetails,
  },
  props: {
    type: {
      type: String,
      default: '未知'
    },
    toAdd: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

      isComponents: '',

      teacherName: '',
      teacherArr: [],

      newClassType: '',
      newClassTypeList: [
        {id:1,name:'规划'},
        {id:2,name:'线下'},
        {id:3,name:'纯补课'},
      ],

      studentStatus: 8,
      studentStatusList: [
        {id:1,name:'在读'},
        {id:2,name:'结业'},
        {id:3,name:'停课'},
        {id:4,name:'流失'},
        {id:8,name:'全部'},
      ],

      regionName: '',
      optionsListt: [],

      dateTimeList: [],


      showPopUpNotification: false,
      params_ZUJIAN: null,

      courseType: 1,
      courseTypeList:[
        {
          name: '按周计算',
          id: 1
        },
        {
          name: '按月计算',
          id: 2
        }
      ],



      dateList: [{}], // 用于存储日期列表
      calculationType: 1, // 1: 差异率, 2: 差值, 3: 无差异率


      dataTableList: [], // 用于存储表格数据

      pageSize: 10,
      pageNum: 1,
      total: 0,

      TabsType: 'student',

      fonttype: {
          name1: '',
          name2: '',
          name3: '',
          name4: ''
      },

      isMub: 0, 

      SubjectGroupList: [],
      SubjectGroup: '',
       
    }
  },

  computed: {
   
  },

  mounted() {
    this.SubjectGroupList = JSON.parse(sessionStorage.getItem('SubjectGroupList'))


    let typeFont = this.type === '首次课图表' ? '首次课渠道占比' : 
                        this.type === '新增率图表' ? '新增课渠道占比' : 
                          this.type === '到课率图表' ? '到课率渠道占比' : 
                            this.type === '取消率图表' ? '取消课渠道占比' : 
                              this.type === '流失率图表' ? '流失课渠道占比' : 
                                this.type === '续报率图表' ? '续报率图表' : ''

    this.isMub = this.type === '首次课图表' ? 1 : 
                    this.type === '新增率图表' ? 2 : 
                       this.type === '到课率图表' ? 3 : 
                          this.type === '取消率图表' ? 4 : 
                            this.type === '流失率图表' ? 5 : 
                              this.type === '续报率图表' ? 6 : 0



    if(typeFont === '首次课渠道占比'){
        this.fonttype = {   name1: '首次课总数', name2: '线下', name3: '规划', name4: '纯补课'  }
    }
    
    if(typeFont === '新增课渠道占比'){
        this.fonttype = {   name1: '新增课总数', name2: '线下新增课', name3: '规划新增课', name4: '纯补课新增课'  }
    }

    if(typeFont === '到课率渠道占比'){
       this.fonttype = {   name1: '整体到课率', name2: '线下到课率', name3: '规划到课率', name4: '纯补课到课率'  }
    }

    if(typeFont === '取消课渠道占比'){
       this.fonttype = {   name1: '整体取消课', name2: '线下取消课', name3: '规划取消课', name4: '纯补课取消课'  }
    }

    if(typeFont === '流失课渠道占比'){
       this.fonttype = {   name1: '整体学生流失数/率', name2: '线下学生流失数/率', name3: '规划学生流失数/率', name4: '纯补课学生流失数/率'  }
    }



     getStudentsType(2).then(res => {
         let data = res.data
         getStudentsType(1).then(_res => {
              this.teacherArr = [...data,..._res.data]
         })
     })


    //  getTeachers_s().then((res) => {  this.teacherArr = res.data   })
     axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
        this.optionsListt = res.data.data
     })

     if(this.isMub === 3){
        this.handleGetDateTime()
     }else{
        this.dateTimeList = this.getDefaultDateRange()
     }

     this.handleGetDateList();

  },

  methods: {

    formatDate(date) {
          const y = date.getFullYear();
          let m = date.getMonth() + 1; // Months are zero based
          let d = date.getDate();
          m = m < 10 ? '0' + m : m;
          d = d < 10 ? '0' + d : d;
          return `${y}-${m}-${d}`;
    },


    getDefaultDateRange() {
        const today = new Date();
        const year = today.getFullYear();
        let startMonth = today.getMonth() - 6; // 半年前的月份
        let startYear = year;
        
        // 调整年份和月份，确保开始月份正确
        if (startMonth < 0) {
            startMonth += 12;
            startYear -= 1;
        }
        
        // 开始日期总是当月的第一天
        const startDate = new Date(startYear, startMonth, 1);
        
        // 结束日期是当前月份的最后一天
        const endYear = today.getFullYear();
        const endMonth = today.getMonth();
        const endDate = new Date(endYear, endMonth + 1, 0); // 0表示前一个月的最后一天

        this.courseType = 1

        return [this.formatDate(startDate), this.formatDate(endDate)];
    },

    handleGetDateTime(){
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth();
      const currentDate = now.getDate();
      const currentDay = now.getDay();
      const lastMonday = new Date(currentYear, currentMonth, currentDate - currentDay - 6);
      const lastSunday = new Date(currentYear, currentMonth, currentDate - currentDay);
      const lastMondayFormatted = `${lastMonday.getFullYear()}-${lastMonday.getMonth() + 1 < 10 ? '0' + (lastMonday.getMonth() + 1) : lastMonday.getMonth() + 1}-${lastMonday.getDate() > 10 ? lastMonday.getDate() : '0' + lastMonday.getDate()}`;
      const lastSundayFormatted = `${lastSunday.getFullYear()}-${lastSunday.getMonth() + 1 < 10 ? '0' + (lastSunday.getMonth() + 1) : lastSunday.getMonth() + 1}-${lastSunday.getDate() > 10 ? lastSunday.getDate() : '0' + lastSunday.getDate()}`;
      this.dateTimeList = [lastMondayFormatted, lastSundayFormatted];

      this.courseType = 1
      
    },

    handleSizeChange(e){
       this.pageSize = e
       this.handleGetDateList()
    },

    handleCurrentChange(e){
       this.pageNum = e
       this.handleGetDateList()
    },

    showPopUpNotificationCler() {
      this.params_ZUJIAN = null;
      this.showPopUpNotification = false;
    },


    details(row) {
      this.isComponents =  this.isMub === 1 ? 'fistClassComponents' : 
                             this.isMub === 2 ? 'feedBackComponents' : 
                              this.isMub === 3 ? 'feedBackComponents' : 
                               this.isMub === 4 ? 'asYouPleaseComponents' : 
                                this.isMub === 5 ? 'TurnoverRateDetails' : 
                                 this.isMub === 6 ? 'ContinuationRateEChartDetails' : 'fistClassComponents'

      row.dateTimeList = this.dateTimeList.length > 1 ? this.dateTimeList : [],
      row.courseType = this.courseType,
      this.params_ZUJIAN = {
        studentId:row.studentId,
        startTime: this.dateTimeList .length > 1 ? this.dateTimeList[0] : '',
        endTime: this.dateTimeList .length > 1 ? this.dateTimeList[1] : '',
        regionName: this.regionName,
        classType: this.newClassType,
        courseType:this.courseType,
        studentStatus: this.studentStatus,
      };
      this.showPopUpNotification = true;
    },

    handleSearch() {
       this.pageNum = 1
       this.pageSize = 10
       this.handleGetDateList();
    },

    handleClear() {
      this.teacherName = '';
      this.newClassType = '';
      this.regionName = '';
      this.studentStatus = 8
      // this.dateTimeList = this.getDefaultDateRange() ;
      this.pageSize = 10
      this.pageNum = 1
      this.courseType = 1
      this.total = 0
      
     if(this.isMub === 3){
        this.handleGetDateTime()
     }else{
        this.dateTimeList = this.getDefaultDateRange()
     }

      // this.dateTimeList = this.getDefaultDateRange() 
      this.handleGetDateList();
    },

    handleDownload(){

      loadingUtils.startLoading();

      let data = { 
        studentId: this.teacherName,
        regionName: this.regionName,
        startTime: this.dateTimeList .length > 1 ? this.dateTimeList[0] : '',
        endTime: this.dateTimeList .length > 1 ? this.dateTimeList[1] : '',
        classType: this.newClassType,
        pageSize: this.pageSize ? this.pageSize : 10,
        pageIndex: this.pageNum ? this.pageNum : 1,
        pageNum: this.pageNum ? this.pageNum : 1,
        queryType: 1,
        monthWeekType: this.courseType,
        studentStatus: this.studentStatus,
        exportType: 1
      }


      let url = this.type === '首次课图表' ? '/firstRecordDiagram/exportStudentFirstDiagram' :
                  this.type === '新增率图表' ? '/newCourseDiagram/exportStudentNumCourseDiagram' :
                    this.type === '到课率图表' ? '/scheduleComplete/exportStudentSchedule' :
                      this.type === '取消率图表' ? '/cancelCourseDiagram/exportStudentCancelCourseDiagram' :
                        this.type === '流失率图表' ? '/lossCourseDiagram/exportStudentLossCourseDiagram' :
                          this.type === '续报率图表' ? '/continuedReport/exportStudentContinuedReport' : '/classSales/exportStatistics'

      let xlsxName = this.type === '首次课图表' ? '首次课学生统计数据数量' :
                        this.type === '新增率图表' ? '新增率学生统计' :
                          this.type === '到课率图表' ? '到课率学生统计' :
                            this.type === '取消率图表' ? '取消率学生统计' :
                              this.type === '流失率图表' ? '流失率学生统计' :
                                this.type === '续报率图表' ? '续报率学生统计' : ''

      axios.post(`${apiBaseUrl}${url}`, data, { responseType: "blob", headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((response) => {
        const blob = new Blob([response.data], { type: "application/vnd.ms-excel"})
      
        setTimeout(() => {
          loadingUtils.endLoading()
        }, 500)

        const downloadLink = document.createElement("a")
        downloadLink.href = URL.createObjectURL(blob)
        downloadLink.download =  xlsxName + ".xlsx"
        downloadLink.click()
      }).catch((error) => {
        this.$message.error(error)
        setTimeout(() => {
          loadingUtils.endLoading()
        }, 500)
      })

    },


    handleGetDateList(){

      loadingUtils.startLoading();

      let data = { 
        studentId: this.teacherName,
        regionName: this.regionName,
        startTime: this.dateTimeList .length > 1 ? this.dateTimeList[0] : '',
        endTime: this.dateTimeList .length > 1 ? this.dateTimeList[1] : '',
        classType: this.newClassType,
        pageSize: this.pageSize ? this.pageSize : 10,
        pageIndex: this.pageNum ? this.pageNum : 1,
        pageNum: this.pageNum ? this.pageNum : 1,
        queryType: 1,
        monthWeekType: this.courseType,
        studentStatus: this.studentStatus,
      }


      let url = this.type === '首次课图表' ? '/firstRecordDiagram/queryStudentFirstDiagramNum' :
                  this.type === '新增率图表' ? '/newCourseDiagram/queryStudentCourseDiagram' :
                    this.type === '到课率图表' ? '/scheduleComplete/queryScheduleCompleteStudent' :
                      this.type === '取消率图表' ? '/cancelCourseDiagram/queryStudentCourseDiagram' :
                        this.type === '流失率图表' ? '/lossCourseDiagram/queryStudentCourseDiagram' :
                          this.type === '续报率图表' ? '/continuedReport/queryStudentContinuedReportDiagram' : '/classSales/exportStatistics'



     
      axios.post(`${apiBaseUrl}${url}`, data ,{ headers: {'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
         if(res.data.code === 200){
            if(res.data.code === 200){


              let datas = null
              let arr = []
             

              if(this.isMub === 3){

                datas = res.data.data

                this.total = datas.total
                this.pageSize = datas.size
                this.pageNum = datas.current
                this.dataTableList = datas.records
                this.dateList = datas.records

              }


              if(this.isMub === 1 || this.isMub === 2){
                 datas = res.data.data

                 this.total = datas.allTotal
                 this.pageSize = datas.pageSize
                 this.pageNum = datas.pageIndex

                 this.dataTableList = datas.entity
                 this.dateList = datas


                 datas && datas.entity.map((item) => {
                      console.log(item)
                      arr.push({
                        channelOfflineNumber: Number(item.channelOfflineNumber),
                        channelMakeNumber: Number(item.channelMakeNumber),
                        channelProjectNumber: Number(item.channelProjectNumber),
                      })
                 })

              }

             
              if(this.isMub === 4){
                 datas = res.data.data

                 this.total = datas.allTotal
                 this.pageSize = datas.pageSize
                 this.pageNum = datas.pageIndex

                 this.dataTableList = datas.entity
                 this.dateList = datas


                 datas && datas.entity.map((item) => {
                      console.log(item)
                      arr.push({
                        channelOfflineNumber: Number(item.channelOfflineNumber),
                        channelMakeNumber: Number(item.channelMakeNumber),
                        channelProjectNumber: Number(item.channelProjectNumber),
                      })
                 })

              }



              if(this.isMub === 5){
                 datas = res.data.data
                 this.total = datas.allTotal
                 this.pageSize = datas.pageSize
                 this.pageNum = datas.pageIndex
                 this.dataTableList = datas.entity
              }


              if(this.isMub === 6){
                 datas = res.data.data

                 this.total = datas.allTotal
                 this.pageSize = datas.pageSize
                 this.pageNum = datas.pageIndex

                 this.dataTableList = datas.entity
                 this.dateList = datas


                 datas && datas.entity.map((item) => {
                      console.log(item)
                      arr.push({
                        channelOfflineNumber: Number(item.channelOfflineNumber),
                        channelMakeNumber: Number(item.channelMakeNumber),
                        channelProjectNumber: Number(item.channelProjectNumber),
                      })
                 })

              }


              
              setTimeout(() => {
                loadingUtils.endLoading()
                // this.$message({ type: 'success', message: '查询学生' + this.type + '成功~' + this.type })
              }, 500)

              

              this.chartData = arr.length > 0 ? arr : []

            }else{
              setTimeout(() => {
                loadingUtils.endLoading()
                this.dateList = []
                this.chartData = []
                this.$message({ type: 'error', message: res.data.message ? res.data.message : '出错了，请联系管理员~'  })
              }, 500)
            }
         }else{
             setTimeout(() => {
              loadingUtils.endLoading()
              this.dateList = []
              this.chartData = []
              this.$message({ type: 'error', message: res.data.message ? res.data.message : '出错了，请联系管理员~'  })
            }, 500)
         }
      }).catch(err => {
          setTimeout(() => {
            loadingUtils.endLoading()
            this.dateList = []
            this.chartData = []
            this.$message({ type: 'error', message: err.message ? err.message : '出错了，请联系管理员~'  })
          }, 500)
      })

    },
   

  },


}


</script>




<style  scoped>

.btns{
   background-color: #428BCA;
   border-color: #428BCA;
   color: #fff;
}



</style>




// WEBPACK FOOTER //
// src/CourseTypeAnalysisEchart/FistClassTable/FistClassTableStudentStart.vue